<template>
  <v-container fluid grid-list-lg>
    <v-layout>
      <v-flex
        xs12
        lg12
        offset-lg0
        xl8
        offset-xl2
        fill-height
      >
        <div v-if="this.betriebe">
          <div v-if="this.betriebe.length > 0">
            <h3 class="headline mt-0">Vorgestellte Betriebe {{ this.betriebe.length }}
              <v-btn icon  @click="getBetriebe()" :loading="isLoading">
              <v-icon >refresh</v-icon>
            </v-btn>
            </h3>

            <v-layout
              row
              wrap
            >
              <v-flex
                xs12 sm6 md4 lg3
                v-for="betrieb in this.betriebe"
                :key="betrieb.id"
                mb-3
              >       {{ betrieb.id }}
               <vorgestellter-betrieb :betrieb="betrieb"></vorgestellter-betrieb>       
                           
              </v-flex>
            </v-layout>
            

          </div>
          <div
            v-else
            class="text-xs-center"
          >
            <v-progress-circular
              indeterminate
              color="accent"
            ></v-progress-circular>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
  
<script>
import axios from 'axios'
// import VorgestellterBetrieb from '~/components/listing/ListingBetrieb.vue'
import VorgestellterBetrieb from '~/components/startseite/VorgestellterBetrieb.vue'

export default {
  data: () => ({
    show: false,
    dialog: false,
    isLoading: false,
    betriebe: []
  }),
  components: {
    VorgestellterBetrieb
  },
  mounted () {
    this.getBetriebe()
  },
  methods: {
    getBetriebe: function () {
      this.isLoading = true
      const self = this
      axios.get('/api/v1/vorgestelltebetriebe', {
        params: {
          menge: 300
        }
      })
      .then(response => {
        // console.log(response)
        self.betriebe = response.data
        self.isLoading = false
      })
    .finally(() => {
      self.isLoading = false
    })
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix
    }
  }
}
</script>

<style>
</style>
